import { notifyLayoutValuesChanged } from './layoutValuesChanged';
import { fetchMethod } from './apiGate'
import { resolveHistoryTimezone } from './historyTimezone'
import { API_URL } from '../config'
import { clientWithoutEndCustomerRemover } from '../services/util/miscellaneousService'
import {
  formatAutocompleteOptions,
  formatPendingDashboardData
} from '../services/util/formatter'
import { mockDataTabList } from '../services/mockingData/MockData'
import * as FormData from 'form-data'

const fetchCsvExport = async (url, data = null, method = 'get') => {
  const response = await fetchMethod(url, data, method, true)
  const csv = response?.data

  if (typeof csv !== 'string' || csv.trim().length === 0) {
    throw new Error('Export response did not contain CSV data')
  }

  return csv
}

const getSearchKeywordsQuery = (queryString) => {
  if (typeof queryString !== 'string' || !queryString.trim()) return ''

  return `&keywords=${encodeURIComponent(queryString)}`
}

const ApiCalls = () => ({
  // Auth Routes
  verifyDomain: async (email) => {
    // {email}
    return fetchMethod(
      `${API_URL}/auth/verifyDomain`,
      email,
      'post',
      false
    ).catch((e) => {
      console.error(e)
    })
  },
  login: async (data) => {
    // {idtoken, identity}
    return fetchMethod(`${API_URL}/auth/login`, data, 'post', false).catch(
      (e) => {
        console.log('Error in login: api.js', e)
      }
    )
  },
  logout: async (data) => {
    // { application_state: { activeUrL, activeTab, searchedString, mapBounds}}
    return fetchMethod(`${API_URL}/auth/logout`, data, 'post', true).catch(
      (e) => {
        console.log('Error in logout: api.js', e)
      }
    )
  },
  guestLogin: async (email, dk) => {
    return fetchMethod(`${API_URL}/auth2/guests/initiate`, { dk, email }, 'post', false).catch(
      (e) => {
        console.log('Error in guest login: ApiCalls.js', e)
      }
    )
  },
  confirmGuestToken: async (token) => {
    return fetchMethod(`${API_URL}/auth2/guests/confirm`, { token }, 'post', false).catch(
      (e) => {
        console.log('Error in guest token confirm: ApiCalls.js', e)
      }
    )
  },
  loginInfo: async () => {
    return fetchMethod(`${API_URL}/auth/info`, {}, 'get', true).catch(
      (e) => {
        console.log('Error in loginInfo: ApiCalls.js', e)
      }
    )
  },
  // Feature Routes
  getAllFeatures: async (data) => {
    // { sortBy, order, pageNo, itemsPerPage }
    return fetchMethod(`${API_URL}/feature/getAll`, data, 'post', true).catch(
      (e) => {
        console.log('Error in getAllFeatures: api.js', e)
      }
    )
  },
  getFeatureById: async (featureId) => {
    return fetchMethod(
      `${API_URL}/feature/getFeatureById/${featureId}`,
      'none',
      'post',
      true
    ).catch((e) => {
      console.log('Error in getFeatureById: api.js', e)
    })
  },
  // Group Routes
  getAllGroups: async (data) => {
    // { sortBy, order, pageNo, itemsPerPage, }
    return fetchMethod(`${API_URL}/group/getAll`, data, 'post', true).catch(
      (e) => {
        console.log('Error in getAllGroups: api.js', e)
      }
    )
  },
  getGroupById: async (groupId) => {
    return fetchMethod(
      `${API_URL}/group/getGroupById/${groupId}`,
      'none',
      'post',
      true
    ).catch((e) => {
      console.log('Error in getGroupById: api.js', e)
    })
  },
  // Location Routes
  searchLocation: async (data) => {
    // {"queryString":"Calgary","mapBounds":{"ne":{"lat":60.09449373906529,"lng":-94.90698063124998},"sw":{"lat":39.88791704763371,"lng":-133.00756656874998}}}
    //return fetchMethod(`${API_URL}/location/search`, data, 'post', true).catch(
    const keywordsQuery = getSearchKeywordsQuery(data.queryString)

    if (data.range)
    {
      return fetchMethod(`${API_URL}/search/locations?bound[]=POLYGON((${data.mapBounds.ne.lng} ${data.mapBounds.ne.lat}, ${data.mapBounds.sw.lng} ${data.mapBounds.ne.lat}, ${data.mapBounds.sw.lng} ${data.mapBounds.sw.lat}, ${data.mapBounds.ne.lng} ${data.mapBounds.sw.lat}, ${data.mapBounds.ne.lng} ${data.mapBounds.ne.lat}))${keywordsQuery}&types[]=asset&types[]=entity`,
      null,
      'get',
      true).catch(
      (e) => {
        console.log('Error in searchLocation: api.js', e)
      })
    }else
    {
      return fetchMethod(`${API_URL}/search/locations?bound[]=POLYGON((-180 180, -180 -180, 180 -180, 180 180, -180 180))${keywordsQuery}&types[]=asset&types[]=entity`,
      null,
      'get',
      true).catch(
      (e) => {
        console.log('Error in searchLocation: api.js', e)
      })
    }
  },

  searchExecutive: async (data) => {
    if (data.groupId)
    {
      return fetchMethod(`${API_URL}/search/executive?groupId=${data.groupId}`,
        null,
        'get',
        true
      )
    }
  },

  searchZone: async (data) => {
    if (data.name)
    {
      return fetchMethod(`${API_URL}/search/zone?name=${data.name}&types[]=asset`,
        null,
        'get',
        true
      ).catch((e) => { 
        console.log('Error Searching by Zone Name', e) 
      })
    }
    if (data.zoneId)
    {
      return fetchMethod(`${API_URL}/search/zone?zoneId=${data.zoneId}&types[]=asset`,
        null,
        'get',
        true
      ).catch((e) => { 
        console.log('Error Searching by Zone Name', e) 
      })
    }
  },

  searchLocationArea: async (data) => {
    // { queryString, mapBounds }
    return fetchMethod(
      `${API_URL}/location/searchArea`,
      data,
      'post',
      true
    ).catch((e) => {
      console.log('Error in searchLocationArea: api.js', e)
    })
  },
  // updateAddressCoordinates : async (data) => {
  //     return fetchMethod(`${API_URL}/location/updateCoordinates`, data, "post", true)
  //             .catch(e => {
  //                 console.log("Error in updateAddressCoordinates: api.js", e)
  //             })
  // },
  getQuickView: async (id) => {
    return fetchMethod(
      `${API_URL}/location/getQuickView/${id}`,
      null,
      'get',
      true
    ).catch((e) => {
      console.log('Error in getQuickView: api.js', e)
    })
  },
  getAsset: async (id) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/assets/${id}`,
        null,
        'get',
        true
      )

      return res.data.data
    } catch(e) {
      console.log(e)
      console.log('Error when fetching Asset Information')
    }
  },
  listAssetsByEntityId: async (id) => {
    try{
      const res = await fetchMethod(
        `${API_URL}/assets?entity_id=${id}`,
        null,
        'get',
        true
      )
      return res.data.data
    } catch(e) {
      console.log('Error getting asset list for entity id', e)
    }
  },
  getEntity: async (id) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/entities/${id}`,
        null,
        'get',
        true
      )
      return res.data.data
    }catch(e) {
      console.log(e)
      console.log('Error when fetching Entity Information')
    }
  },
  getLocationDetailsById: async (id) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/getLocationDetailsById/${id}`,
        null,
        'get',
        true
      )
      return res.data.data
    } catch (e) {
      console.log('Error in getLocationDetailsById: api.js', e)
    }
  },
  //old Endpoint getAccountDetailsById
  getContractById: async (accountId, data) => {
    return fetchMethod(
      `${API_URL}/contracts/${accountId}`,
      data,
      'get',
      true
    ).catch((e) => {
      console.log('Error in getContractById: api.js', e)
    })
  },
  getContractsByAssetId: async (assetId) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/contracts?asset_id=${assetId}`,
        null,
        'get',
        true
      )
      return res.data.data
    }catch(e) {
      console.log('Error in geting contracts by asset ID', e)
    }
  },
  getServicesById: async (serviceId) => {
    return fetchMethod(
      `${API_URL}/services/${serviceId}`,
      'none',
      'get',
      true
    )
      .then((res) => {
        if (res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in getServicesById: api.js', e)
      })
  },
  getContacts: async (id) => {
    return fetchMethod(
      `${API_URL}/location/getContacts/${id}`,
      null,
      'get',
      true
    ).catch((e) => {
      console.log('Error in getContacts: api.js', e)
    })
  },

  listContactTypes: async (params) => {
    return fetchMethod(
      `${API_URL}/parties/~/types`,
      null,
      'get',
      true,
      null,
      params,
    ).then((res) =>{
      if (res.data.data)
      {
        return res.data.data
      }else
      {
        return []
      }
    }).catch((e) => {
      console.log('Error getting contact types')
    })
  },
  listServiceTypes: async (params) => {
    return fetchMethod(
      `${API_URL}/services/~/types`,
      null,
      'get',
      true,
      null,
      params
    ).then((res) =>{
      if(res.data.data)
      {
        return res.data.data
      }else
      {
        return []
      }
    }).catch((e) => {
      console.log('Error getting service types')
    })
  },
  listServiceCategories: async (params) => {
    return fetchMethod(
      `${API_URL}/services/~/categories`,
      null,
      'get',
      true,
      null,
      params
    ).then((res) =>{
      if(res.data.data)
      {
        return res.data.data
      }else
      {
        return []
      }
    }).catch((e) => {
      console.log('Error getting service types')
    })
  },
  getPartyById: async (contactId) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/parties/${contactId}`,
        null,
        'get',
        true
      )
      return res.data.data
    } catch (err) {
      console.log('Error in getPatryById: api.js', err)
    }
  },

  getAllFieldTypes: async (contactId) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dynamic/getAllFieldTypes`,
        null,
        'get',
        true
      )
      return res.data.data
    } catch (err) {
      console.log('Error in getAllFieldTypes:', err)
    }
  },

  getAllJobTitles: async () => {
    return fetchMethod(
      `${API_URL}/location/getAllJobTitles`,
      null,
      'get',
      true
    ).catch((e) => {
      console.log('Error in getAllJobTitles: api.js', e)
    })
  },
  updateServiceByServiceId: async (serviceId, data) => {
    // data = {desc, link}
    return fetchMethod(
      `${API_URL}/location/updateService/${serviceId}`,
      data,
      'put',
      true
    ).catch((e) => {
      console.log('Error in updateServicesByid: api.js', e)
    })
  },
  updateMultipleService: async (data) => {
    return fetchMethod(
      `${API_URL}/location/updateMultipleService`,
      data,
      'put',
      true
    ).catch((e) => {
      console.log('Error in updateMultipleService: api.js', e)
    })
  },
  updateTrainingRecords: async (recordId, data) => {
    return fetchMethod(
      `${API_URL}/location/updateTrainingRecords/${recordId}`,
      data,
      'post',
      true
    ).catch((e) => {
      console.log('Error in updateTrainingRecords: api.js', e)
    })
  },
  updateMultipleTrainingRecords: async (data) => {
    return fetchMethod(
      `${API_URL}/location/updateMultipleTrainingRecords`,
      data,
      'put',
      true
    ).catch((e) => {
      console.log('Error in updateMultipleTrainingRecords: api.js', e)
    })
  },
  updateContact: async (contactId, data) => {
    return fetchMethod(
      `${API_URL}/location/updateContact/${contactId}`,
      data,
      'put',
      true
    ).catch((e) => {
      console.log('Error in updateContact: api.js', e)
    })
  },
  updateLocationDetails: async (id, data) => {
    return fetchMethod(
      `${API_URL}/location/updateLocationDetails/${id}`,
      data,
      'put',
      true
    ).catch((e) => {
      console.log('Error in updateLocationDetails: api.js', e)
    })
  },
  createImage: async (id, data) => {
    return fetchMethod(
      `${API_URL}/location/createImage/${id}`,
      data,
      'post',
      true
    ).catch((e) => {
      console.log('Error in createImage: api.js', e)
    })
  },
  deleteImage: async (imageId) => {
    return fetchMethod(
      `${API_URL}/location/deleteImage/${imageId}`,
      null,
      'delete',
      true
    ).catch((e) => {
      console.log('Error in deleteImage: api.js', e)
    })
  },

  getImageByAssetId: async (assetId) => {
    return fetchMethod(
      `${API_URL}/assets/${assetId}?include[]=images`,
      null,
      'get',
      true
    ).catch((e => {
      console.log('Error in getImageByAssetId', e)
    }
    ))
  },

  searchBuildingByName: async (keyword) => {
    return fetchMethod(
      `${API_URL}/location/searchBuildingByName`,
      keyword,
      'post',
      true
    )
      .then((res) => {
        if (res.data.data.error) {
          return []
        } else {
          return res.data.data
        }
      })
      .catch((e) => {
        console.log('Error in searchBuildingByName: api.js', e)
      })
  },
  searchPeople: async ({
    sortBy,
    order,
    pageNo,
    itemsPerPage,
    searchInput,
    searchType
  }) => {
    return fetchMethod(
      `${API_URL}/people/search`,
      { sortBy, order, pageNo, itemsPerPage, searchInput, searchType },
      'post',
      true
    ).catch((e) => {
      console.log('Error in searchUsers: api.js', e)
    })
  },
  getBuildingAndAddressByBuildingId: async (buildingId) => {
    return await fetchMethod(
      `${API_URL}/location/getBuildingAndAddressByBuildingId`,
      buildingId,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          const response = res.data.data
          if (response.bec_building_id === null) response.bec_building_id = ''
          if (response.line_1 === null) response.line_1 = ''
          if (response.line_2 === null || response.line_2 === undefined)
            response.line_2 = ''
          if (response.city === null) response.city = ''
          if (response.state === null) response.state = ''
          if (response.country === null) response.country = ''
          if (response.zip_postcode === null) response.zip_postcode = ''
          if (response.address_id === null) response.address_id = ''
          // if(response.phone_number === null) response.phone_number = ''

          return response
        }
        return {}
      })
      .catch((e) => {
        console.log('Error in getBuildingAndAddressByBuildingId: api.js', e)
      })
  },
  searchAccountByName: async (data) => {
    return await fetchMethod(
      `${API_URL}/location/searchAccountByName`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return clientWithoutEndCustomerRemover(res.data.data)
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in searchAccountByName: api.js', e)
        return []
      })
  },

  getExecutiveEntityDetail: async (id) => {
    const res = await fetchMethod(
      `${API_URL}/search/executive/entity/${id}`,
      null,
      'get',
      true
    )
    return res.data
  },
  searchAllAccountsByName: async (data) => {
    const response = await fetchMethod(
      `${API_URL}/location/searchAccountByName`,
      data,
      'post',
      true
    )
    const accounts = response?.data?.data

    if (!Array.isArray(accounts)) {
      throw new Error('Account search response did not contain an account list')
    }

    return accounts
  },
  searchLocationByName: async (data) => {
    return fetchMethod(
      `${API_URL}/location/searchLocationByName`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in searchLocationByName: api.js', e)
      })
  },
  searchContactByName: async (data) => {
    return fetchMethod(
      `${API_URL}/location/searchContactByName`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in searchContactByName: api.js', e)
      })
  },
  getAssignedLocationsByContactId: async (contactId) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/people/assignedLocations/${contactId}`,
        {},
        'get',
        true
      )
      return res.data.data
    } catch (e) {
      console.log('Error in getAssignedLocationsByContactId: api.js', e)
    }
  },
  getAllContactType: async () => {
    return fetchMethod(
      `${API_URL}/location/getAllContactType`,
      null,
      'get',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in getAllContactType: api.js', e)
      })
  },
  getAllServiceTypes: async () => {
    return fetchMethod(
      `${API_URL}/location/getAllServiceTypes`,
      null,
      'get',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in getAllServiceTypes: api.js', e)
      })
  },
  getServiceByNameAndType: async (data) => {
    return fetchMethod(
      `${API_URL}/location/getServiceByNameAndType`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in getServiceByNameAndType: api.js', e)
      })
  },
  linkExistingServicesToExistingLocation: async (data) => {
    return fetchMethod(
      `${API_URL}/data-import/service-to-location`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log(
          'Error in linkExistingServicesToExistingLocation: api.js',
          e
        )
      })
  },
  addExistingContactsToExistingLocation: async (data) => {
    return fetchMethod(
      `${API_URL}/data-import/contact-to-location`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in addExistingContactsToExistingLocation: api.js', e)
      })
  },
  addNewContactsToExistingLocation: async (data) => {
    return fetchMethod(
      `${API_URL}/data-import/new-contact-to-location`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in addNewContactsToExistingLocation: api.js', e)
      })
  },
  addNewLocationToExistingClient: async (data) => {
    return fetchMethod(
      `${API_URL}/data-import/new-location-to-client`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in addNewLocationToExistingClient: api.js', e)
      })
  },
  addNewLocationToNewClient: async (data) => {
    return fetchMethod(
      `${API_URL}/data-import/new-location-to-new-client`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in addNewLocationToNewClient: api.js', e)
      })
  },
  searchContractorAccountByName: async (data) => {
    return fetchMethod(
      `${API_URL}/location/searchContractorAccountByName`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in searchContractorAccountByName: api.js', e)
      })
  },
  searchBuildingByProvince: async (data) => {
    return fetchMethod(
      `${API_URL}/location/searchBuildingByProvince`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in searchBuildingByProvince: api.js', e)
      })
  },
  addressExistenceCheck: async (data) => {
    return fetchMethod(
      `${API_URL}/location/validateAddress`,
      data,
      'post',
      true
    )
      .then((res) => {
        return res.data && res.data.data
      })
      .catch((e) => {
        console.log('Error in addressExistenceCheck: api.js', e)
      })
  },
  getAllTrainingRecordTypes: async () => {
    return fetchMethod(
      `${API_URL}/location/getAllTrainingRecordTypes`,
      null,
      'get',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        }
        return []
      })
      .catch((e) => {
        console.log('Error in getAllTrainingRecordTypes: api.js', e)
      })
  },
  // Resource Routes
  getAllResources: async (data) => {
    // { sortBy, order, pageNo, itemsPerPage, }
    return fetchMethod(`${API_URL}/resource/getAll`, data, 'post', true).catch(
      (e) => {
        console.log('Error in getAllResources: api.js', e)
      }
    )
  },
  getResourceById: (resourceId) => {
    return fetchMethod(
      `${API_URL}/resource/getResourceById/${resourceId}`,
      'none',
      'post',
      true
    ).catch((e) => {
      console.log('Error in getAllResources: api.js', e)
    })
  },
  // User Routes
  getAllUsers: async (data) => {
    // { sortBy, order, pageNo, itemsPerPage, }
    return fetchMethod(`${API_URL}/users/list`, data, 'post', true).catch(
      (e) => {
        console.log('Error in getAllUsers: api.js', e)
      }
    )
  },
  getUserDetailsById: async (userId) => {
    return fetchMethod(
      `${API_URL}/users/userDetails/${userId}`,
      'none',
      'post',
      true
    ).catch((e) => {
      console.log('Error in getUserDetailsById: api.js', e)
    })
  },
  searchApprover: async (data) => {
    return await fetchMethod(`${API_URL}/users/searchUser`, data, 'post', true)
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in getUserDetailsById: api.js', e)
      })
  },
  // Notification Route
  notifyApprover: async (data) => {
    return fetchMethod(
      `${API_URL}/notification/notifyApprover`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          return res.data.data
        } else {
          return []
        }
      })
      .catch((e) => {
        console.log('Error in notifyApprover: api.js', e)
      })
  },
  // Data Import Route
  getAllPendingDataImports: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/data-import/getAllPendingDataImports`,
        'none',
        'get',
        true
      )
      return res.data.data.data || []
    } catch (e) {
      console.log('Error in getAllPendingDataImports: api.js', e)
    }
  },
  getPendingDataImport: async (data) => {
    return fetchMethod(
      `${API_URL}/data-import/getPendingDataImport`,
      data,
      'post',
      true
    )
      .then((res) => {
        if (res && res.data && res.data.data && res.data.data.data) {
          return res.data.data.data[0]
        }
      })
      .catch((e) => {
        console.log('Error in getPendingDataImport: api.js', e)
      })
  },
  approvePendingData: async (data) => {
    return fetchMethod(
      `${API_URL}/data-import/approvePendingData`,
      data,
      'post',
      true
    )
      .then((res) => {
        return res
      })
      .catch((e) => {
        console.log('Error in approvePendingData: api.js', e)
      })
  },
  rejectPendingData: async (data) => {
    return fetchMethod(
      `${API_URL}/data-import/rejectPendingData`,
      data,
      'post',
      true
    )
      .then((res) => {
        return res
      })
      .catch((e) => {
        console.log('Error in rejectPendingData: api.js', e)
      })
  },

  searchGroups: async (searchInput) => {
    try {
      return await fetchMethod(
        `${API_URL}/group/searchGroup`,
        searchInput,
        'post',
        true
      )
    } catch (e) {
      console.log('Error in searchGroups: api.js', e)
    }
  },

  checkGroupNameDuplicate: async (groupName) => {
    try {
      return await fetchMethod(
        `${API_URL}/group/checkDuplicateName`,
        { groupName },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in checkGroupNameDuplicate: api.js', e)
    }
  },

  getAllFeaturesList: async () => {
    try {
      return await fetchMethod(
        `${API_URL}/feature/getAllFeatures`,
        '',
        'get',
        true
      )
    } catch (e) {
      console.log('Error in getAllFeaturesList: api.js', e)
    }
  },

  getAllResourcesList: async () => {
    try {
      return await fetchMethod(
        `${API_URL}/resource/getAllResources`,
        '',
        'get',
        true
      )
    } catch (e) {
      console.log('Error in getAllResourcesList: api.js', e)
    }
  },

  /**
   *
   * @param {string} groupId Id of the group you want to assign to
   * @param {Array<string>} resourceIdList Array of resource ids
   * @returns {Promise<AxiosResponse<any>>}
   */
  assignResourcesToGroup: async (groupId, resourceIdList) => {
    try {
      return await fetchMethod(
        `${API_URL}/resource/assignResources`,
        { groupId, resourceIdList },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in assignResourcesToGroup: api.js', e)
    }
  },

  /**
   *
   * @param {string} groupName Name of the group you want to remove from
   * @param {string} groupId Id of the group you want to remove from
   * @param {Array<string>} resourceIdList Array of resource ids
   * @returns {Promise<AxiosResponse<any>>}
   */
  removeResourcesFromGroup: async (groupName, groupId, resourceIdList) => {
    try {
      return await fetchMethod(
        `${API_URL}/resource/removeResourcesFromGroup`,
        { groupName, groupId, resourceIdList },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in removeResourcesFromGroup: api.js', e)
      return Promise.reject(e.response)
    }
  },

  /**
   *
   * @param {string} groupId Id of the group you want to assign to
   * @param {Array<string>} featureIdList Array of feature ids
   * @returns {Promise<AxiosResponse<any>>}
   */
  assignFeaturesToGroup: async (groupId, featureIdList) => {
    try {
      return await fetchMethod(
        `${API_URL}/feature/assignFeatures`,
        { groupId, featureIdList },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in assignFeaturesToGroup: api.js', e)
    }
  },

  /**
   *
   * @param {string} groupName Name of the group you want to remove from
   * @param {string} groupId Id of the group you want to remove from
   * @param {Array<string>} featureIdList Array of feature ids
   * @returns {Promise<AxiosResponse<any>>}
   */
  removeFeaturesFromGroup: async (groupName, groupId, featureIdList) => {
    try {
      return await fetchMethod(
        `${API_URL}/feature/removeFeaturesFromGroup`,
        { groupName, groupId, featureIdList },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in removeFeaturesFromGroup: api.js', e)
      return Promise.reject(e.response)
    }
  },

  /**
   *
   * @param {string} groupId Id of the group you want to assign to
   * @param {Array<string>} userIdList Array of user ids
   * @returns {Promise<AxiosResponse<any>>}
   */
  assignUsersToGroup: async (groupId, userIdList) => {
    try {
      return await fetchMethod(
        `${API_URL}/users/assignUsersToGroup`,
        { groupId, userIdList },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in assignUsersToGroup: api.js', e)
    }
  },

  /**
   *
   * @param {string} groupName Name of the group you want to remove from
   * @param {string} groupId Id of the group you want to remove from
   * @param {Array<string>} userIdList Array of user ids
   * @returns {Promise<AxiosResponse<any>>}
   */
  removeUsersFromGroup: async (groupName, groupId, userIdList) => {
    try {
      return await fetchMethod(
        `${API_URL}/users/removeUsersFromGroup`,
        { groupName, groupId, userIdList },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in removeUsersFromGroup: api.js', e)
      return Promise.reject(e.response)
    }
  },

  /**
   *
   * @param {string} name Name of the resource
   * @param {string} description Description of the resource
   * @param {string} owner Id of resource owner
   * @param {string} resourceType Id resource type
   * @returns {Promise<AxiosResponse<any>>}
   */
  createNewResource: async (name, description, owner, resourceType) => {
    try {
      return await fetchMethod(
        `${API_URL}/resource/createNewResource`,
        { name, description, owner, resourceType },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in createNewResource: api.js', e)
    }
  },

  /**
   *
   * @param {string} name Name of the resource
   * @param {string} description Description of the resource
   * @param {string} resourceId Id of resource
   * @returns {Promise<AxiosResponse<any>>}
   */
  updateResource: async (name, description, resourceId) => {
    try {
      return await fetchMethod(
        `${API_URL}/resource/updateResource`,
        { name, description, resourceId },
        'put',
        true
      )
    } catch (e) {
      console.log('Error in updateResource: api.js', e)
    }
  },

  /**
   *
   * @param {string} name
   * @param {string} description
   * @param {Array<String>} ownerId
   * @param {Array<String>} resourceIdList
   * @param {Array<String>} featureIdList
   * @param {Array<String>} userIdList
   * @return {Promise<void>}
   */
  createGroup: async (
    name,
    description,
    ownerId,
    resourceIdList,
    featureIdList,
    userIdList
  ) => {
    try {
      return await fetchMethod(
        `${API_URL}/group/createGroup`,
        {
          name,
          description,
          ownerId,
          resourceIdList,
          featureIdList,
          userIdList
        },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in createGroup: api.js', e)
    }
  },

  /**
   *
   * @param {string} name
   * @param {string} description
   * @param {string} newOwnerId
   * @param {string} existingOwnerId
   * @param {uuid} groupId
   * @return {Promise<AxiosResponse<any>>}
   */
  updateGroup: async (
    name,
    description,
    newOwnerId,
    existingOwnerId,
    groupId
  ) => {
    try {
      return await fetchMethod(
        `${API_URL}/group/updateGroup`,
        { name, description, newOwnerId, groupId },
        'put',
        true
      )
    } catch (e) {
      console.log('Error in updateGroup: api.js', e)
    }
  },

  /**
   * calls /groupMember/:userId under user routes
   * @param userId
   * @returns {Promise<Array<string>>} list of group names that user is member of
   */
  getUserMemberGroups: async (userId) => {
    try {
      return await fetchMethod(
        `${API_URL}/users/groupMember/${userId}`,
        null,
        'get',
        true
      ).then((res) => {
        return res.data.data
      })
    } catch (e) {
      console.log('Error in getUserMemberGroups: api.js', e)
    }
  },

  /**
   * calls /groupOwner/:userId under user routes
   * @param userId
   * @returns {Promise<Array<string>>} list of group names that user is owner of
   */
  getUserOwnerGroups: async (userId) => {
    try {
      return await fetchMethod(
        `${API_URL}/users/groupOwner/${userId}`,
        null,
        'get',
        true
      ).then((res) => {
        return res.data.data
      })
    } catch (e) {
      console.log('Error in getUserOwnerGroups: api.js', e)
    }
  },

  logClientForm: async () => {
    try {
      await fetchMethod(`${API_URL}/log/clientForm`, null, 'post', true)
    } catch (e) {
      console.log('Error in logClientForm: api.js', e)
    }
  },

  logLocationForm: async () => {
    try {
      await fetchMethod(`${API_URL}/log/locationForm`, null, 'post', true)
    } catch (e) {
      console.log('Error in logLocationForm: api.js', e)
    }
  },

  logPeopleForm: async () => {
    try {
      await fetchMethod(`${API_URL}/log/peopleForm`, null, 'post', true)
    } catch (e) {
      console.log('Error in logPeopleForm: api.js', e)
    }
  },

  logServiceForm: async () => {
    try {
      await fetchMethod(`${API_URL}/log/serviceForm`, null, 'post', true)
    } catch (e) {
      console.log('Error in logServiceForm')
    }
  },

  /**
   * calls /locations under export routes
   * @returns {Promise<string>} csv data in string format
   */
  getAllLocationsCsvData: async () => {
    return fetchCsvExport(`${API_URL}/export/locations`)
  },

  /**
   * calls /contacts under export routes
   * @returns {Promise<string>} csv data in string format
   */
  getAllContactsCsvData: async () => {
    return fetchCsvExport(`${API_URL}/export/contacts`)
  },

  /**
   * calls /services under export routes
   * @returns {Promise<string>} csv data in string format
   */
  getAllServicesCsvData: async () => {
    return fetchCsvExport(`${API_URL}/export/services`)
  },

  /**
   * calls /clients under export routes
   * @returns {Promise<string>} csv data in string format
   */
  getAllClientsCsvData: async () => {
    return fetchCsvExport(`${API_URL}/export/accounts`)
  },

  /**
   * calls /locations/account/:accountId under export routes
   * @param {uuid} accountId
   * @returns {Promise<string>} csv data in string format
   */
  getAllLocationsCsvDataForClient: async (accountId) => {
    return fetchCsvExport(`${API_URL}/export/locations/account/${accountId}`)
  },

  /**
   * calls /locations/service/:serviceId under export routes
   * @param {uuid} serviceId
   * @returns {Promise<string>} csv data in string format
   */
  getAllLocationsCsvDataForService: async (serviceId) => {
    return fetchCsvExport(`${API_URL}/export/locations/service/${serviceId}`)
  },

  /**
   * calls /locations/contact/:contactId under export routes
   * @param {uuid} contactId
   * @returns {Promise<string>} csv data in string format
   */
  getAllLocationsCsvDataForContact: async (contactId) => {
    return fetchCsvExport(`${API_URL}/export/locations/contact/${contactId}`)
  },

  /**
   * calls /training/contact/:contactId under export routes
   * @param {uuid} contactId
   * @returns {Promise<string>} csv data in string format
   */
  getAllTrainingRecordsForContact: async (contactId) => {
    return fetchCsvExport(`${API_URL}/export/training/contact/${contactId}`)
  },

  /**
   * calls /account/:accountId under export routes
   * @param {uuid} accountId
   * @returns {Promise<string>} csv data in string format
   */
  getClientDetailsCsvData: async (accountId) => {
    return fetchCsvExport(`${API_URL}/export/account/${accountId}`)
  },

  /**
   * Fetches data-change audit records from the legacy /logs/activity route.
   * @returns {Promise<string>} csv data in string format
   */
  getDataChangeLogs: async (fromDate, toDate) => {
    return fetchCsvExport(
      `${API_URL}/export/logs/activity`,
      { fromDate, toDate },
      'post'
    )
  },

  /**
   * Fetches user-activity audit records from the legacy /logs/data route.
   * @returns {Promise<string>} csv data in string format
   */
  getUserActivityLogs: async (fromDate, toDate) => {
    return fetchCsvExport(
      `${API_URL}/export/logs/data`,
      { fromDate, toDate },
      'post'
    )
  },

  getContactTemplate: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/bulkImport/contactTemplate`,
        {},
        'get',
        true
      )
      return res.data
    } catch (e) {
      console.log('Error in getContactTemplate')
    }
  },
  getLocationTemplate: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/bulkImport/locationTemplate`,
        {},
        'get',
        true
      )
      return res.data
    } catch (e) {
      console.log('Error in getLocationTemplate')
    }
  },
  bulkImportLocation: async (userId, locationList, accountId, accountName) => {
    await fetchMethod(
      `${API_URL}/bulkImport/locations`,
      { userId, locationList, accountId, accountName },
      'post',
      true
    )
  },
  bulkImportContact: async (userId, contactList, id) => {
    await fetchMethod(
      `${API_URL}/bulkImport/contacts`,
      { userId, contactList, id },
      'post',
      true
    )
  },

  searchLocationByAccountName: async (searchInput, accountName) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/searchLocationByAccountName`,
        { searchInput, accountName },
        'post',
        true
      )
      return res.data
    } catch (e) {
      console.log('Error in searchLocationByAccountName')
    }
  },
  getDashboardData: async (locationId) => {
    try {
      const dashboardData = await fetchMethod(
        `${API_URL}/dashboard/latestDataPoint`,
        { locationId },
        'post',
        true
      )
      const commentData = await fetchMethod(
        `${API_URL}/dashboard/latestComment`,
        { locationId },
        'post',
        true
      )

      return {
        dashboardData: dashboardData.data,
        commentData: commentData.data
      }
    } catch (e) {
      console.log('Error in getDashboardData')
    }
  },
  getWidgetsData: async (locationId) => {
    try {
      return await fetchMethod(
        `${API_URL}/dashboard/latestDataPoint`,
        { locationId },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in getWidgetsData')
    }
  },
  getLineChartDataByid: async (locationId, startDate, endDate) => {
    try {
      const dashboardData = await fetchMethod(
        `${API_URL}/dashboard/defaultDashboard`,
        { locationId },
        'post',
        true
      )

      return dashboardData.data
    } catch (e) {
      console.log('Error in getLineChartDataByid')
    }
  },

  getLineChartDataByDateRange: async (locationId, startDate, endDate) => {
    try {
      const dashboardData = await fetchMethod(
        `${API_URL}/dashboard/dateRange`,
        { locationId, startDate, endDate },
        'post',
        true
      )
      return dashboardData.data.data
    } catch (e) {
      console.log('Error in getLineChartDataByDateRange')
    }
  },

  getCommentByDate: async (locationId, date) => {
    try {
      const dashboardData = await fetchMethod(
        `${API_URL}/dashboard/commentByDate`,
        { locationId, date },
        'post',
        true
      )
      return dashboardData.data.data[0]
    } catch (e) {
      console.log('Error in getCommentByDate')
    }
  },
  getPaginatedComments: async (
    locationId,
    sortBy,
    order,
    pageNo,
    itemsPerPage
  ) => {
    try {
      const commentData = await fetchMethod(
        `${API_URL}/dashboard/paginatedComments`,
        { locationId, sortBy, order, pageNo, itemsPerPage },
        'post',
        true
      )
      return commentData.data
    } catch (e) {
      console.log('Error in getPaginatedComments')
    }
  },

  getPaginatedDashboardData: async (
    locationId,
    sortBy,
    order,
    pageNo,
    itemsPerPage
  ) => {
    try {
      const dashboardData = await fetchMethod(
        `${API_URL}/dashboard/paginatedDashboard`,
        { locationId, sortBy, order, pageNo, itemsPerPage },
        'post',
        true
      )
      return dashboardData.data
    } catch (e) {
      console.log('Error in getPaginatedDashboardData')
    }
  },

  getTemplateComment: async () => {
    try {
      const dashboardData = await fetchMethod(
        `${API_URL}/dashboard/templateComment`,
        {},
        'get',
        true
      )
      return dashboardData.data
    } catch (e) {
      console.log('Error in getPaginatedDashboardData')
    }
  },

  getTemplateDashboard: async () => {
    try {
      const dashboardData = await fetchMethod(
        `${API_URL}/dashboard/templateDashboard`,
        {},
        'get',
        true
      )
      return dashboardData.data
    } catch (e) {
      console.log('Error in getPaginatedDashboardData')
    }
  },

  bulkImportComments: async (userId, commentList, locationId) => {
    await fetchMethod(
      `${API_URL}/dashboard/bulkComment`,
      { userId, commentList, locationId },
      'post',
      true
    )
  },

  bulkImportDashboardData: async (
    userId,
    dashboardDataList,
    locationId,
    timeZone
  ) => {
    await fetchMethod(
      `${API_URL}/dashboard/bulkDashboard`,
      { userId, dashboardDataList, locationId, timeZone },
      'post',
      true
    )
  },

  importSingleComment: async (
    commenterName,
    comment,
    commenterType,
    locationId,
    createdBy,
    approver,
    date,
    initiatorEmail
  ) => {
    await fetchMethod(
      `${API_URL}/dashboard/comment`,
      {
        commenterName,
        comment,
        commenterType,
        locationId,
        createdBy,
        approver,
        date,
        initiatorEmail
      },
      'post',
      true
    )
  },
  importSingleDashboardMetrics: async (
    clientScore,
    inspectionScore,
    complianceScore,
    reportCount,
    incidentCount,
    locationId,
    approver,
    createdBy,
    date,
    initiatorEmail
  ) => {
    await fetchMethod(
      `${API_URL}/dashboard/dashboardData`,
      {
        clientScore: clientScore || '',
        inspectionScore: inspectionScore || '',
        complianceScore: complianceScore || '',
        reportCount: reportCount || '',
        incidentCount: incidentCount || '',
        locationId,
        approver,
        createdBy,
        date,
        initiatorEmail
      },
      'post',
      true
    )
  },

  getCommenterTypes: async () => {
    try {
      const commenterTypes = await fetchMethod(
        `${API_URL}/dashboard/commenterTypes`,
        {},
        'get',
        true
      )
      return commenterTypes.data
    } catch (e) {
      console.log('Error in getCommenterTypes')
    }
  },

  editCommentsPending: async (
    commentList,
    locationId,
    createdBy,
    approver,
    initiatorEmail
  ) => {
    try {
      const commenterTypes = await fetchMethod(
        `${API_URL}/dashboard/comment`,
        { commentList, locationId, createdBy, approver, initiatorEmail },
        'put',
        true
      )
      return commenterTypes.data
    } catch (e) {
      console.log('Error in getCommenterTypes')
    }
  },

  editDashboardData: async (
    dataPointList,
    locationId,
    createdBy,
    approver,
    initiatorEmail
  ) => {
    try {
      const commenterTypes = await fetchMethod(
        `${API_URL}/dashboard/dashboardData`,
        { dataPointList, locationId, createdBy, approver, initiatorEmail },
        'put',
        true
      )
      return commenterTypes.data
    } catch (e) {
      throw e
    }
  },

  deleteComments: async (
    commentIdList,
    locationId,
    createdBy,
    approver,
    initiatorEmail
  ) => {
    try {
      console.log(
        commentIdList,
        locationId,
        createdBy,
        approver,
        initiatorEmail
      )
      await fetchMethod(
        `${API_URL}/dashboard/comment`,
        { commentIdList, locationId, createdBy, approver, initiatorEmail },
        'delete',
        true
      )
    } catch (e) {
      console.log('Error in deleteComments')
    }
  },

  deleteDashboardData: async (
    dataPointIdList,
    locationId,
    createdBy,
    approver,
    initiatorEmail
  ) => {
    try {
      console.log(
        dataPointIdList,
        locationId,
        createdBy,
        approver,
        initiatorEmail
      )
      await fetchMethod(
        `${API_URL}/dashboard/dashboardData`,
        { dataPointIdList, locationId, createdBy, approver, initiatorEmail },
        'delete',
        true
      )
    } catch (e) {
      console.log('Error in deleteDashboardData')
    }
  },

  getPendingDashboardData: async (pendingDataId) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dashboard/singlePendingData/${pendingDataId}`,
        {},
        'get',
        true
      )

      return formatPendingDashboardData(res)
    } catch (e) {
      console.log('Error in getPendingDashboardData')
      throw e
    }
  },

  approvePendingDashboardData: async (pendingDataId) => {
    await fetchMethod(
      `${API_URL}/dashboard/approveData`,
      { pendingDataId },
      'post',
      true
    )
  },

  rejectPendingDashboardData: async (
    pendingDataId,
    rejectMessage,
    initiatorEmail
  ) => {
    try {
      console.log(pendingDataId, rejectMessage, initiatorEmail)
      const res = await fetchMethod(
        `${API_URL}/dashboard/rejectData`,
        { dataId: pendingDataId, rejectMessage, initiatorEmail },
        'post',
        true
      )
      return res
    } catch (e) {
      console.log('Error in rejectPendingDashboardData')
      throw e
    }
  },

  getAllPendingDashboardData: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dashboard/pendingData`,
        {},
        'get',
        true
      )
      return res.data || []
    } catch (e) {
      console.log('Error in getAllPendingDashboardData')
    }
  },

  getTotalPendingByUserId: async (userId) => {
    try {
      const countDataImport = await fetchMethod(
        `${API_URL}/data-import/getTotalPendingByUserId`,
        { userId },
        'post',
        true
      )
      const countDashboardImport = await fetchMethod(
        `${API_URL}/dashboard/getTotalPendingByUserId`,
        { userId },
        'post',
        true
      )

      return (
        parseInt(countDashboardImport.data) + parseInt(countDataImport.data)
      )
    } catch (e) {
      console.log('Error in getTotalPendingByUserId')
    }
  },
  overwriteInsert: async (importType, data, userId) => {
    const response = await fetchMethod(
      `${API_URL}/dashboard/insertDirectData`,
      { importType, data, userId },
      'post',
      true
    )
    if (response?.data?.success !== true) {
      throw new Error(typeof response?.data?.error === 'string'
        ? response.data.error
        : 'Unable to save dashboard data. Please try again.')
    }
    return response.data
  },
  reOpenRejected: async (pendingDataId, commentData, dashboardData) => {
    await fetchMethod(
      `${API_URL}/dashboard/reOpenRejectedData`,
      { pendingDataId, commentData, dashboardData },
      'post',
      true
    )
  },
  searchApprovers: async (searchInput, locationId) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dashboard/searchApprovers`,
        { searchInput, locationId },
        'post',
        true
      )
      return res.data.data
    } catch (e) {
      console.log('Error in searchApprovers')
      return []
    }
  },
  searchLocationInDataSet: async (data) => {
    // { queryString, mapBounds, dataSet }
    return fetchMethod(
      `${API_URL}/location/searchInDataSet`,
      data,
      'post',
      true
    ).catch((e) => {
      console.log('Error in searchLocationInDataSet: api.js', e)
    })
  },

  getCategoryOptions: async () => {
    try {
      return mockOptions
      // let res = await fetchMethod(`${API_URL}/`,
      //     {}, "get", true)
      // return res.data.data
    } catch (e) {
      console.log('Error in getCategoryOptions')
      return []
    }
  },
  getLocationSizeRange: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/locationSizeRange`,
        {},
        'get',
        true
      )
      const { highest, lowest } = res.data.data
      return {
        min: lowest.location_floor_area,
        max: highest.location_floor_area
      }
    } catch (e) {
      console.log('Error in getLocationSizeRange')
      return []
    }
  },
  getBusinessSizeRange: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/businessSizeRange`,
        {},
        'get',
        true
      )
      const { highest, lowest } = res.data.data
      return { min: lowest.business_size, max: highest.business_size }
    } catch (e) {
      console.log('Error in getBusinessSizeRange')
      return []
    }
  },
  getBuildingTypes: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/buildingTypes`,
        {},
        'get',
        true
      )
      return formatAutocompleteOptions(
        res.data.data,
        'building_type_id',
        'building_type_name'
      )
    } catch (e) {
      console.log('Error in getBuildingTypes')
      return []
    }
  },
  getEntitiesTypes: async (params) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/entities/~/types`,
        {},
        'get',
        true,
        null,
        params
      )
      return response.data.data
    }catch(e)
    {
      console.log('Error getting entities types', e)
      return []
    }
  },
  createEntityType: async (type) => {
    try{
      const response = await fetchMethod(
        `${API_URL}/entities/~/types`,
        type,
        'post',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error creating entities types', e)
      return []
    }
  },
  updateEntityType: async (id, type) => {
    try{
      const response = await fetchMethod(
        `${API_URL}/entities/~/types/${id}`,
        type,
        'put',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error updating entities types', e)
      return []
    }
  },
  getEntityTypeDeletionImpact: async (id) => {
    const response = await fetchMethod(
      `${API_URL}/entities/~/types/${id}/deletion-impact`,
      null,
      'get',
      true
    )
    return response.data
  },
  deleteEntityType: async (id) => {
    try{
      const response = await fetchMethod(
        `${API_URL}/entities/~/types/${id}`,
        null,
        'delete',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error deletion entities types', e)
      throw e
    }
  },
  getIndustries: async (params) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/industries`,
        {},
        'get',
        true,
        null,
        params
      )
      return response.data.data
    }catch(e)
    {
      console.log('Error getting inductries', e)
      return []
    }
  },
  createIndustry: async (industry) => {
    try{
      const response = await fetchMethod(
        `${API_URL}/industries`,
        industry,
        'post',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error creating inductries', e)
      return []
    }
  },
  updateIndustry: async (id, industry) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/industries/${id}`,
        industry,
        'put',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error updating industries', e)
      return []
    }
  },
  createContactCategory: async (category) => {
    try{
      const response = await fetchMethod(
        `${API_URL}/parties/~/types`,
        category,
        'post',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error creating contact category', e)
      return []
    }
  },
  updateContactCategory: async (id, category) => {
    try{
      const response = await fetchMethod(
        `${API_URL}/parties/~/types/${id}`,
        category,
        'put',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error updating contact category', e)
      return []
    }
  },
  getContactCategoryDeletionImpact: async (id) => {
    const response = await fetchMethod(
      `${API_URL}/parties/~/types/${id}/deletion-impact`,
      null,
      'get',
      true
    )
    return response.data
  },
  deleteContactCategory: async (id) => {
    try{
      const response = await fetchMethod(
        `${API_URL}/parties/~/types/${id}`,
        null,
        'delete',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error deleting contact category', e)
      throw e
    }
  },
  listJobTitles: async (params) => {
    return fetchMethod(
      `${API_URL}/jobtitles`,
      null,
      'get',
      true,
      null,
      params
    ).then((res) =>{
      if (res.data.data)
      {
        return res.data.data
      }else
      {
        return []
      }
    }).catch((e) => {
      console.log('Error getting list of job titles')
    })
  },
  createJobTitle: async (title) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/jobtitles`,
        title,
        'post',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error creating job title', e)
      return []
    }
  },
  updateJobTitle: async (id, title) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/jobtitles/${id}`,
        title,
        'put',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error updating job title', e)
      return []
    }
  },
  getJobTitleDeletionImpact: async (id) => {
    const response = await fetchMethod(
      `${API_URL}/jobtitles/${id}/deletion-impact`,
      null,
      'get',
      true
    )
    return response.data
  },
  deleteJobTitle: async (id) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/jobtitles/${id}`,
        null,
        'delete',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error deleting job title', e)
      throw e
    }
  },
  createServiceType: async (type) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/services/~/types`,
        type,
        'post',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error creating service type', e)
      return []
    }
  },
  updateServiceType: async (id, type) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/services/~/types/${id}`,
        type,
        'put',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error updating service type', e)
      return []
    }
  },
  getServiceTypeDeletionImpact: async (id) => {
    const response = await fetchMethod(
      `${API_URL}/services/~/types/${id}/deletion-impact`,
      null,
      'get',
      true
    )
    return response.data
  },
  deleteServiceType: async (id) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/services/~/types/${id}`,
        {},
        'delete',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error updating service type', e)
      throw e
    }
  },
  createServiceCategory: async (category) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/services/~/categories`,
        category,
        'post',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error creating service type', e)
      return []
    }
  },
  updateServiceCategory: async (id, category) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/services/~/categories/${id}`,
        category,
        'put',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error updating service type', e)
      return []
    }
  },
  getServiceCategoryDeletionImpact: async (id) => {
    const response = await fetchMethod(
      `${API_URL}/services/~/categories/${id}/deletion-impact`,
      null,
      'get',
      true
    )
    return response.data
  },
  deleteServiceCategory: async (id) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/services/~/categories/${id}`,
        {},
        'delete',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error updating service type', e)
      throw e
    }
  },
  getIndustryDeletionImpact: async (id) => {
    const response = await fetchMethod(
      `${API_URL}/industries/${id}/deletion-impact`,
      null,
      'get',
      true
    )
    return response.data
  },
  deleteIndustry: async (id) => {
    try {
      const response = await fetchMethod(
        `${API_URL}/industries/${id}`,
        {},
        'delete',
        true
      )
      return response.data
    }catch(e)
    {
      console.log('Error deleteing industries', e)
      throw e
    }
  },
  //Dynamic Tabs
  listLayout: async (objectType) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dynamicfields/layouts?object_type=${objectType}`,
        {},
        'get',
        true
      )
      return res.data.data
    }catch (e)
    {
      console.log('Error Listing Layouts', e)
      return []
    }
  },
  getLayout: async (objectType, id) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dynamicfields/layouts?object_type=${objectType}&ids[]=${id}`,
        {},
        'get',
        true
      )
      return res.data.data
    }catch (e)
    {
      console.log('Error Getting Layout', e)
      return []
    }
  },
  getLayoutHistory: async (id, { date, timezone, objectType, subjectType = 'asset' }) => {
    const query = new URLSearchParams({ subject_type: subjectType, object_type: objectType, as_of_date: date, timezone: resolveHistoryTimezone(timezone) });
    const res = await fetchMethod(`${API_URL}/dynamicfields/${encodeURIComponent(id)}/history?${query}`, {}, 'get', true);
    if (!res?.data?.data) throw new Error('Unable to load historical data');
    return res.data.data;
  },
  submitHistoryCorrection: async (payload) => {
    const res = await fetchMethod(`${API_URL}/dynamicfields/history/corrections`, payload, 'post', true);
    if (!Array.isArray(res?.data?.data) || !res.data.data.length || res.data.data.some((row) => !['pending_approval', 'approved', 'rejected'].includes(row.status))) throw new Error('Unable to submit correction');
    for (const row of res.data.data) if (row.status === 'approved') notifyLayoutValuesChanged(row.proposal?.subject_id);
    return res.data.data;
  },
  listHistoryCorrections: async ({ subjectId, subjectType = 'asset', mine = true, status = 'pending_approval', page = 1 }) => {
    const query = new URLSearchParams({ mine: String(mine), page: String(page), page_size: '10' });
    if (subjectId) { query.set('subject_type', subjectType); query.set('subject_id', subjectId); }
    if (status) query.set('status', status);
    const res = await fetchMethod(`${API_URL}/dynamicfields/history/corrections?${query}`, {}, 'get', true);
    if (!Array.isArray(res?.data?.data) || !res.data.pagination) throw new Error('Unable to load corrections');
    return res.data;
  },
  reviewHistoryCorrection: async (id, payload) => {
    const res = await fetchMethod(`${API_URL}/dynamicfields/history/corrections/${encodeURIComponent(id)}/review`, payload, 'post', true);
    if (!res?.data?.data?.id) throw new Error('Unable to review correction');
    if (res.data.data.status === 'approved') notifyLayoutValuesChanged(res.data.data.proposal?.subject_id);
    return res.data.data;
  },
  getLayoutByAsset: async (objectType, assetId) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dynamicfields/layouts?object_type=${objectType}&for_asset_id=${assetId}`,
        {},
        'get',
        true
      )
      return res.data.data
    }catch (e)
    {
      console.log('Error Getting Layout', e)
    }
  },
  createLayout: async (layout) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dynamicfields/layouts`,
        layout,
        'post',
        true
      )
      return res.data.data
    }catch (e)
    {
      console.log('Error Creating Layout', e)
      throw e
    }
  },
  updateLayout: async (id, layout) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dynamicfields/layouts/${id}`,
        layout,
        'put',
        true
      )
      return res.data.data
    }catch (e)
    {
      console.log('Error Updating Layout', e)
      throw e
    }
  },
  deleteLayout: async (id) => {
    try {
      await fetchMethod(
        `${API_URL}/dynamicfields/layouts/${id}`,
        {},
        'delete',
        true
      )
      return
    } catch (e)
    {
      console.log('Error Deleting Layout', e)
      return []
    }
  },
  getFields: async (ids) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dynamicfields/fields?ids[]=${ids}`,
        {},
        'get',
        true
      )
      return res.data.data
    }catch (e)
    {
      console.log('Error getting fields', e)
      return []
    }
  },
  listFields: async (fieldTypeIn = []) => {
    try {
      let allData = []
      const perPage = 100

      const buildUrl = (page = 0) => {
        const params = new URLSearchParams()
        params.set('per_page', perPage.toString())

        if (page > 0) {
          params.set('page', page.toString())
        }

        if (Array.isArray(fieldTypeIn) && fieldTypeIn.length > 0) {
          fieldTypeIn.forEach((type) => {
            params.append('field_type_in[]', type)
          })
        }

        return `${API_URL}/dynamicfields/fields?${params.toString()}`
      }

      const firstRes = await fetchMethod(buildUrl(0), {}, 'get', true)
      const { data = [], pagination } = firstRes?.data || {}
      allData.push(...data)

      if (pagination) {
        const totalPages = Math.ceil(pagination.total / pagination.per_page)
        for (let page = 1; page < totalPages; page++) {
          const nextRes = await fetchMethod(buildUrl(page), {}, 'get', true)
          const nextData = nextRes?.data?.data || []
          allData.push(...nextData)
        }
      }

      return allData
    } catch (e) {
      console.log('Error getting fields', e)
      return []
    }
  },

  createField: async (field) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dynamicfields/fields`,
        field,
        'post',
        true
      )
      return res.data.data
    }catch (e)
    {
      console.log('Error creating field', e)
      return []
    }
  },

  updateField: async (id, field) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dynamicfields/fields/${id}`,
        field,
        'put',
        true
      )
      return res.data.data
    }catch (e)
    {
      console.log('Error updating field', e)
      return []

    }
  },

  deleteField: async (id) => {
    try {
      await fetchMethod(
        `${API_URL}/dynamicfields/fields/${id}`,
        {},
        'delete',
        true
      )
      return
    }catch (e)
    {
      console.log('Error deleting field', e)
      throw e
    }
  },
  getValues: async (id, subject_type, objectid) => {
    if (objectid)
    {
      try{
        const res = await fetchMethod(
          `${API_URL}/dynamicfields/${id}/values?subject_type=${subject_type}&object_ids[]=${objectid}`,
          {},
          'get',
          true
        )
        return res.data.data
      }catch (e)
      {
        console.log('Error getting values', e)
        return []
      }
    }else
    {
      try{
        const res = await fetchMethod(
          `${API_URL}/dynamicfields/${id}/values?subject_type=${subject_type}`,
          {},
          'get',
          true
        )
        return res.data.data
      }catch (e)
      {
        console.log('Error getting values', e)
        return []
      }
    }
  },
  setValues: async (values) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/dynamicfields/values`,
        values,
        'post',
        true
      )
      notifyLayoutValuesChanged();
      if (res.data.warnings?.length) {
        return { error: res.data.warnings.join('; '), data: res.data.data }
      }
      return res.data.data
    } catch (e) {
      console.log('Error setting values:', e)
      let errorMessage = e.message
      if (
        e.response &&
        e.response.data &&
        Array.isArray(e.response.data.errors) &&
        e.response.data.errors.length > 0
      ) {
        errorMessage = e.response.data.errors[0].message
      }
      return { error: errorMessage }
    }
  },
  getZones: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/zones`,
        {},
        'get',
        true
      )
      return formatAutocompleteOptions(res.data.data, '', 'fmz')
    } catch (e) {
      console.log('Error in getZones')
      return []
    }
  },
  getJobTitles: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/jobTitles`,
        {},
        'get',
        true
      )
      return formatAutocompleteOptions(res.data.data, '', 'job_title')
    } catch (e) {
      console.log('Error in getJobTitles')
      return []
    }
  },
  advancedSearch: async (
    queryString,
    dataSet,
    categoryOne,
    categoryTwo,
    filterType
  ) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/advancedSearch`,
        { queryString, dataSet, categoryOne, categoryTwo, filterType },
        'post',
        true
      )
      console.log(res)
    } catch (e) {
      console.log('Error in advancedSearch')
    }
  },
  advancedSearchEmpty: async (
    dataSet,
    categoryOne,
    categoryTwo,
    filterType
  ) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/advancedSearchEmpty`,
        { dataSet, categoryOne, categoryTwo, filterType },
        'post',
        true
      )
      console.log(res)
    } catch (e) {
      console.log('Error in advancedSearch')
    }
  },
  updateAppearanceConfiguration: () => {
    // return fetchMethod(`${API_URL}/`,
    //     {}, "put", true)
  },

  getEndCustomers: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/endCustomer`,
        {},
        'get',
        true
      )
      return res && res.data && res.data.endCustomerList
    } catch (e) {
      console.log('Error in getEndCustomers')
    }
  },

  getAllIcons: async () => {
    try {
      const res = await fetchMethod(`${API_URL}/setting/icons`, {}, 'get', true)

      return res && res.data && res.data.iconList
    } catch (e) {
      console.log('Error in getAllIcons')
    }
  },

  /**
   * accepts list of objects {endCustomerId, color, iconId}
   * @returns {Promise<void>}
   */
  insertIconMapping: async (iconMapping) => {
    try {
      await fetchMethod(
        `${API_URL}/setting/endCustomerIcon`,
        { iconMapping },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in insertIconMapping')
    }
  },

  getAllLandingOptions: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/landingOptions`,
        {},
        'get',
        true
      )
      return res && res.data && res.data.allLandingOptions
    } catch (e) {
      console.log('Error in getAllLandingOptions', e)
    }
  },

  setLandingOptionSystem: async (landingOptionId) => {
    try {
      await fetchMethod(
        `${API_URL}/setting/landingOptionsSystem`,
        { landingOptionId },
        'post',
        true
      )
    } catch (e) {
      console.log('Error in getAllLandingOptions', e)
    }
  },

  getLandingOptionSystem: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/landingOptionsSystem`,
        {},
        'get',
        true
      )
      return res && res.data && res.data.userLandingOption
    } catch (e) {
      console.log('Error in getAllLandingOptions', e)
    }
  },

  addWelcomeMessageTemplate: async (
    templateName,
    title,
    description,
    footer
  ) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/welcomeTemplates`,
        {
          templateInfo: {
            templateName,
            title,
            description,
            footer,
            headerImage: 'null'
          }
        },
        'post',
        true
      )
      return res
    } catch (e) {
      console.log('Error in addWelcomeMessageTemplate', e)
    }
  },
  getAllTemplateOptions: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/welcomeTemplates`,
        {},
        'get',
        true
      )
      return res && res.data && res.data.welcomeTemplates
    } catch (e) {
      console.log('Error in getAllTemplateOptions', e)
    }
  },
  getSettings: async (userId) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/systemSettings`,
        { userId },
        'post',
        true
      )
      console.log(res)
    } catch (e) {
      console.log('Error in getSettings')
    }
  },
  setSettings: async (fontName, iconSetName, themeName) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/settings`,
        { fontName, iconSetName, themeName },
        'post',
        true
      )
      console.log(res)
    } catch (e) {
      console.log('Error in getSettings')
    }
  },
  searchLocationByEndCustomerName: async (searchInput, endCustomerName) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/searchLocationByEndCustomerName`,
        { searchInput, endCustomerName },
        'post',
        true
      )
      return res.data
    } catch (e) {
      console.log('Error in searchLocationByAccountName')
    }
  },

  getTabList: async () => {
    // TODO Integration
    try {
      // await fetchMethod(`${API_URL}/`,
      //     {}, "get", true);
      return mockDataTabList
    } catch (e) {
      console.log('Error in getTabList')
    }
  },

  getTabView: async (id, tabName) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/${id}/tab/${tabName}`,
        {},
        'get',
        true
      )
      return res.data.data
    } catch (e) {
      console.log('Error in getTabView')
    }
  },
  updateTabView: async (id, tabName, data) => {
    try {
      return await fetchMethod(
        `${API_URL}/location/${id}/tab/${tabName}`,
        [...data],
        'put',
        true
      )
    } catch (e) {
      console.log('Error in updateTabLayout')
    }
  },
  getTabLayout: async (tabName) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/location/tab/${tabName}`,
        {},
        'get',
        true
      )
      return res.data.data
    } catch (e) {
      console.log('Error in getTabLayout')
    }
  },
  updateTabLayout: async (tabName, data) => {
    try {
      await fetchMethod(`${API_URL}/location/tab/${tabName}`, data, 'put', true)
      return true
    } catch (e) {
      console.log('Error in updateTabLayout')
    }
  },

  updateAvatar: async (partyId, imageFile) => {
    const formData = new FormData()
    formData.append('partyId', partyId)
    if (imageFile) {
      formData.append('avatarFile', imageFile)
    }
    try {
      return await fetchMethod(`${API_URL}/person/avatar`, formData, 'put', true, {
        'content-type': 'multipart/form-data'
      })
    } catch (e) {
      console.log('Error in updateAvatar')
      return null;
    }
  },
  postAvatarFromSSO: async (email, avatarLink) => {
    try {
      await fetchMethod(
        `${API_URL}/person/avatar/sso`,
        { email, avatarLink },
        'post',
        true
      )
      return true
    } catch (e) {
      console.log('Error in postAvatarFromSSO')
    }
  },
  updateLocationImage: async (imageFile, id, tabName) => {
    if (!imageFile?.[0]) return false;

    const formData = new FormData();
    formData.append('locationImage', imageFile[0]);

    try {
      await fetchMethod(
        `${API_URL}/location/${id}/tab/${tabName}/upload`,
        formData,
        'post',
        true
      );
      console.log('Image upload succeeded');
      return true;
    } catch (e) {
      console.error('Error in updateLocationImage', e);
      return false;
    }
  },

  deleteLocationImage: async (selectedphoto, id, tabName) => {
    const formData = new FormData()
    if (selectedphoto) {
      formData.append('locationImage', selectedphoto)
      formData.append('id', id)
      formData.append('tabName', tabName)
    }
    try {
      console.log(`${API_URL}`)
      await fetchMethod(
        `${API_URL}/location/${id}/tab/${tabName}/delete`,
        formData,
        'post',
        true,
        { 'content-type': 'multipart/form-data' }
      )
      // console.log(`${API_URL}/location/${id}/tab/${tabName}/upload`)
      console.log('success')
      return true
    } catch (e) {
      console.log('Error in deleteLocationImage')
    }
  },

  defaultLocationImage: async (selectedphoto, id, tabName) => {
    const formData = new FormData()
    if (selectedphoto) {
      formData.append('locationImage', selectedphoto)
      formData.append('id', id)
      formData.append('tabName', tabName)
    }
    try {
      console.log(`${API_URL}`)
      await fetchMethod(
        `${API_URL}/location/${id}/tab/${tabName}/default`,
        formData,
        'post',
        true
      )
      // console.log(`${API_URL}/location/${id}/tab/${tabName}/upload`)
      console.log('success')
      return true
    } catch (e) {
      console.log('Error in defaultLocationImage')
    }
  },
  googlePullImage: async (isswitch, id, tabName) => {
    try {
      console.log(`${API_URL}`)
      await fetchMethod(
        `${API_URL}/location/${id}/tab/${tabName}/userswitch`,
        { isswitch, id, tabName },
        'post',
        true
      )
      // console.log(`${API_URL}/location/${id}/tab/${tabName}/upload`)
      console.log('success')
      return true
    } catch (e) {
      console.log('Error in defaultLocationImage')
    }
  },
  userStatesPullImage: async (id, tabName) => {
    try {
      console.log(`${API_URL}`)
      const res = await fetchMethod(
        `${API_URL}/location/${id}/tab/${tabName}/userswitchstates`,
        { id, tabName },
        'post',
        true
      )
      // console.log(`${API_URL}/location/${id}/tab/${tabName}/upload`)
      console.log('success')
      return res.data.data
    } catch (e) {
      console.log('Error in defaultLocationImage')
    }
  },

  updateAllusersStatesGoogle: async (isswitch) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/admindashboard`,
        { isswitch },
        'post',
        true
      )
      // console.log(`${API_URL}/location/${id}/tab/${tabName}/upload`)
      console.log('success')
      return res.data.data
    } catch (e) {
      console.log('Error in updateAlluserstatesGoogle')
    }
  },

  getAdminStatesGoogle: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/adminDashboard/getadminstatus`,
        {},
        'put',
        true
      )
      // console.log(`${API_URL}/location/${id}/tab/${tabName}/upload`)
      console.log('success')
      return res.data.data
    } catch (e) {
      console.log('Error in updateAlluserstatesGoogle')
    }
  },

  getFullViewTabSetting: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/adminDashboard/fullViewTabSetting`,
        {},
        'get',
        true
      )
      return res.data.data
    } catch (e) {
      console.log('Error in getFullViewTabSetting', e)
    }
  },
  updateMissingDataFieldVisibility: async (settingValue) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/setting/adminDashboard/missingDataFieldVisibility`,
        { settingValue },
        'put',
        true
      )
      return res.data.data
    } catch (e) {
      console.log('Error in updateMissingDataFieldVisibility')
    }
  },

  getTabs: async () => {
    try {
      const res = await fetchMethod(`${API_URL}/tab`, {}, 'get', true)
      return res.data.data
    } catch (e) {
      console.log('Error in getTabs')
    }
  },

  updateTabs: async (tabList) => {
    try {
      const res = await fetchMethod(`${API_URL}/tab`, { tabList }, 'put', true)
      return res.data.data
    } catch (e) {
      console.log('Error in updateTabs')
    }
  },

  getAllHeatMaps: async () => {
    try {
      const res = await fetchMethod(
        `${API_URL}/heatmaps`,
        undefined,
        'get',
        true,
        {}
      )

      return res
    } catch (e) {
      console.log(`Error in getAllHeatMaps => ${e.message}`)
    }
  },

  /**
   * @param {string} id Heatmap Id
   * @param {AbortSignal} signal optional AbortSignal to cancel the request
   * @return {Promise<AxiosResponse<any>>}
   */
  getAHeatmap: async (id, signal) => {
    /*
      Checking for error (e.g. getDynamicFields) here is good for PromiseAll.
      if error checking is required in app, then following pattern is to be applied
    */
    return fetchMethod(`${API_URL}/heatmaps/${id}`,
      {},
      'get',
      true,
      {},
      {},
      false,
      { signal }
    );
  },

  /**
   * @param {object} data heatmap POST request data
   * @return {Promise<AxiosResponse<any>>}
   */
  saveANewHeatmap: async (data) => {
    /*
      Checking for error (e.g. getDynamicFields) here is good for PromiseAll.
      if error checking is required in app, then following pattern is to be applied
    */
    return fetchMethod(`${API_URL}/heatmaps`, data, 'post', true, {})
  },

  /**
   * @param {string} id Heatmap Id
   * @param {object} data heatmap PUT request data
   * @return {Promise<AxiosResponse<any>>}
   */
  updateAHeatmap: async (id, data) => {
    /*
      Checking for error (e.g. getDynamicFields) here is good for PromiseAll.
      if error checking is required in app, then following pattern is to be applied
    */
    return fetchMethod(`${API_URL}/heatmaps/${id}`, data, 'put', true, {})
  },

  /**
   * @param {string} id Heatmap Id
   * @return {Promise<AxiosResponse<any>>}
   */
  deleteAHeatmap: async (id) => {
    /*
      Checking for error (e.g. getDynamicFields) here is good for PromiseAll.
      if error checking is required in app, then following pattern is to be applied
    */
    return fetchMethod(`${API_URL}/heatmaps/${id}`, {}, 'delete', true, {})
  },

  /**
   * @param {string} id Heatmap Id
   * @param {object} params heatmap query GET request data
   * @param {AbortSignal} signal optional AbortSignal to cancel the request
   * @return {Promise<AxiosResponse<any>>}
   */
  queryAHeatmap: async (id, params, signal) => {
    /*
      Checking for error (e.g. getDynamicFields) here is good for PromiseAll.
      if error checking is required in app, then following pattern is to be applied
    */
    return fetchMethod(
      `${API_URL}/heatmaps/${id}/query`,
      {},
      'get',
      true,
      {},
      params,
      false,
      { signal }
    );
  },

  /**
   * @return {Array | NULL} Array of existing Geo Zones | null
   */
  getAllGeoZones: async () => {
    try {
      const perPage = 100
      const fetchPage = page => fetchMethod(
          `${API_URL}/datazones`,
          undefined,
          'get',
          true,
          {},
          {
            type: 'geo',
            include: ['geozones'],
            sort: '+name',
            page,
            per_page: perPage
          }
        )

      const firstResponse = await fetchPage(0)
      const firstPage = firstResponse?.data?.data ?? []
      const pagination = firstResponse?.data?.pagination
      const pageSize = Number(pagination?.per_page) || perPage
      const total = Number(pagination?.total) || firstPage.length
      const totalPages = Math.max(1, Math.ceil(total / pageSize))

      if (totalPages === 1) return firstPage

      const remainingResponses = await Promise.all(
        Array.from({ length: totalPages - 1 }, (_, index) => (
          fetchPage(index + 1)
        ))
      )

      return remainingResponses.reduce(
        (allGeoZones, response) => (
          allGeoZones.concat(response?.data?.data ?? [])
        ),
        firstPage
      )
    } catch (e) {
      const errorPayload = {
        error: {
          module: 'ApiCalls',
          from: `getAllGeoZones`,
          message: e.message
        }
      }
      console.log(errorPayload)
      return null
    }
  },

  /**
   * @param {string} userId
   * @param {string} type 'favorite' | 'pin'
   * @returns {Array | NUll} Array of items containing the attribute | null
   */
  getHeatmapAttribute: async (userId, type) => {
    try {
      const res = await fetchMethod(
        `${API_URL}/parties/${userId}/favorites`,
        undefined,
        'get',
        true,
        {},
        {
          type: `${type}`
        }
      )

      return res?.data?.data
    } catch (e) {
      const errorPayload = {
        error: {
          module: 'ApiCalls',
          from: `getHeatmapAttribute`,
          message: e.message
        }
      }
      console.log(errorPayload)
      return null
    }
  },

  /**
   * @param {string} userId
   * @param {string} heatmapId
   * @param {string} type 'favorite' | 'pin'
   * @returns {Promise<AxiosResponse<any>>}
   */
  addHeatmapAttribute: async (userId, heatmapId, type) => {
    /*
      Checking for error (e.g. getDynamicFields) here is good for PromiseAll.
      if error checking is required in app, then following pattern is to be applied
    */
    return fetchMethod(
      `${API_URL}/parties/${userId}/favorites`,
      {
        data: [
          {
            party_id: userId,
            item_id: heatmapId,
            category: 'heatmap',
            type: type,
            deleted_at: null
          }
        ]
      },
      'patch',
      true,
      {}
    )
  },
  /**
   * @param {string} userId
   * @param {string} heatmapId
   * @param {string} type 'favorite' | 'pin'
   * @returns {Promise<AxiosResponse<any>>}
   */
  removeHeatmapAttribute: async (userId, heatmapId, type) => {
    /*
      Checking for error (e.g. getDynamicFields) here is good for PromiseAll.
      if error checking is required in app, then following pattern is to be applied
    */
    return fetchMethod(
      `${API_URL}/parties/${userId}/favorites`,
      {
        data: [
          {
            party_id: userId,
            item_id: heatmapId,
            category: 'heatmap',
            type: type,
            deleted_at: `${new Date().toISOString()}`
          }
        ]
      },
      'patch',
      true,
      {}
    )
  }
})


export default ApiCalls

const mockOptions = [
  {
    id: 1,
    name: 'cat-1',
    customName: 'Location Size',
    group: 'places/account',
    type: 'slider'
  },
  {
    id: 2,
    name: 'cat-2',
    customName: 'Business Type',
    group: 'places/account',
    type: 'dropdown'
  },
  {
    id: 3,
    name: 'cat-3',
    customName: 'Building Type',
    group: 'places/account',
    type: 'dropdown'
  },
  {
    id: 4,
    name: 'cat-4',
    customName: 'Industry Type',
    group: 'places/account',
    type: 'dropdown'
  },
  {
    id: 5,
    name: 'cat-5',
    customName: 'Zone',
    group: 'places/account',
    type: 'dropdown'
  },
  {
    id: 6,
    name: 'cat-6',
    customName: 'Job Title',
    group: 'people',
    type: 'dropdown'
  },
  {
    id: 7,
    name: 'cat-7',
    customName: 'Contact Type',
    group: 'people',
    type: 'dropdown'
  },
  {
    id: 8,
    name: 'cat-8',
    customName: 'Service Type',
    group: 'service',
    type: 'dropdown'
  },
  {
    id: 9,
    name: 'cat-9',
    customName: 'Business Size',
    group: 'service',
    type: 'slider'
  },
  {
    id: 10,
    name: 'cat-10',
    customName: 'Zone',
    group: 'service',
    type: 'dropdown'
  }
]
